"use client";

import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarTrigger,
  useSidebar,
} from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import { useI18n } from "@/locales/client";
import { StudygenieBlackHat, StudygenieFullLogo } from "../ui/icons";

const Logo = () => {
  const { open } = useSidebar();
  const t = useI18n();
  return (
    <SidebarMenu>
      <SidebarMenuItem
        className={cn(
          "relative overflow-hidden transition-all duration-300 ease-in-out",
          open ? "flex w-full items-center justify-between" : "size-6",
        )}
      >
        {open ? (
          <>
            <div className="transition-opacity duration-300">
              <StudygenieFullLogo />
            </div>
            <SidebarTrigger
              tooltipContentCollapsed={t("sidebar.showNavigation")}
              tooltipContentExpanded={t("sidebar.hideNavigation")}
            />
          </>
        ) : (
          <div className="relative group/logo">
            <StudygenieBlackHat className="duration-300 ease-in-out transition-opacity group-hover/logo:opacity-0" />
            <SidebarTrigger
              className="absolute left-0 top-0 opacity-0 duration-300 ease-in-out transition-opacity group-hover/logo:opacity-100 w-[22px] h-[24px]"
              tooltipContentCollapsed={t("sidebar.showNavigation")}
              tooltipContentExpanded={t("sidebar.hideNavigation")}
            />
          </div>
        )}
      </SidebarMenuItem>
    </SidebarMenu>
  );
};

export default Logo;
